import { render, staticRenderFns } from "./ForecastingBasePage.vue?vue&type=template&id=13baae14&scoped=true"
import script from "./ForecastingBasePage.vue?vue&type=script&lang=js"
export * from "./ForecastingBasePage.vue?vue&type=script&lang=js"
import style0 from "./ForecastingBasePage.vue?vue&type=style&index=0&id=13baae14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13baae14",
  null
  
)

export default component.exports